import clsx from 'clsx'

import { IconSvg } from 'components/common'

interface Props {
	message: any
	closeButton?: boolean
}

export function Alert({ message, closeButton = false }: Props) {
	return message ? (
		<div
			className={clsx(`p-3 pr-8 rounded-md relative mb-5`, {
				'bg-danger': message.type === 'danger',
				'bg-info': message.type === 'info',
				'bg-success': message.type === 'success',
				'bg-warning': message.type === 'warning',
				'bg-secondary': message.type === 'default',
			})}
		>
			<div className={clsx('absolute top-3 right-3', { hidden: !closeButton })}>
				<button type="button" className="text-primary-text">
					<IconSvg icon="close" className="w-5 h-5" />
				</button>
			</div>
			<div className="flex">
				<div className="w-11 h-11 bg-gradient-to-b from-[rgba(255,255,255,0)] to-[rgba(255,255,255,0.15)] rounded-full flex justify-center items-center flex-shrink-0">
					<IconSvg
						icon={clsx({
							check: message.type === 'success',
							warning: message.type === 'danger' || message.type === 'warning',
							information: message.type === 'info',
						})}
					/>
				</div>
				<div className="pl-4 pt-1 text-left">
					<h5 className="text-sm leading-[18px] font-bold">
						{message.title
							? message.title
							: clsx({
									'Success!': message.type === 'success',
									'Oops ...': message.type === 'danger',
									'Info!': message.type === 'info',
									'Warning!': message.type === 'warning',
								})}
					</h5>
					<p className="text-xs text-primary-text mt-1">{message.description}</p>
				</div>
			</div>
		</div>
	) : null
}
